import axiosHandler from "./axios-handler";

export const handleCourse = async ({ courseEntryUid, courseActivity }) => {
  const options = {
    method: "PUT",
    url: `${process.env.NEXT_PUBLIC_BASE_URL}/v1/users/courses/${courseEntryUid}`,
    withCredentials: true,
    data: {
      ...courseActivity,
      // "isSubscribed": false,
      // "isBookmarked": false,
      // "isLiked": false
    },
  };
  return await axiosHandler(options);
};

const handleLesson = async ({
  courseEntryUid,
  lessonEntryUid,
  lessonActivity,
}) => {
  let query = lessonActivity?.progress
    ? { progress: { ...lessonActivity?.progress } }
    : lessonActivity;
  const options = {
    method: "PUT",
    url: `${process.env.NEXT_PUBLIC_BASE_URL}/v1/users/courses/${courseEntryUid}/lessons/${lessonEntryUid}`,
    withCredentials: true,
    data: {
      ...lessonActivity,
      // "isBookmarked": "{{$randomBoolean}}",
      // "isLiked": "{{$randomBoolean}}",
      // "progress": {
      //   "percentage": "{{_random_number}}",
      //   "hasStarted": "{{$randomBoolean}}",
      //   "isCompleted": "{{$randomBoolean}}",
      // },
    },
  };
  return await axiosHandler(options);
};

const handleBookmarkLesson = async ({ lessonEntryUid, lessonActivity }) => {
  const options = {
    method: "PUT",
    url: `${process.env.NEXT_PUBLIC_BASE_URL}/v1/users/lessons/${lessonEntryUid}`,
    withCredentials: true,
    data: {
      ...lessonActivity,
      // "isSubscribed": false,
      // "isBookmarked": false,
      // "isLiked": false
    },
  };
  return await axiosHandler(options);
};

export default async function updateUserActivity(
  { courseEntryUid, lessonEntryUid, courseActivity, lessonActivity },
  isStandaloneCourse,
  fromSubscribe,
  isLearningPath,
  type
) {
  let coursePath = window.location.pathname
    .replace(/^\//, "")
    .split("/").length;

  const isLearningUrl = window.location.pathname.includes("/learning-paths/");
  if (
    isLearningUrl
      ? coursePath === 4
      : coursePath === 3 || isStandaloneCourse || fromSubscribe
  ) {
    if (type) {
      return await handleBookmarkLesson({
        lessonActivity,
        lessonEntryUid,
      });
    } else {
      return await handleCourse({ courseEntryUid, courseActivity });
    }
  } else if (isLearningUrl ? coursePath === 4 : coursePath === 3) {
    if (isLearningPath) {
      return await handleCourse({ courseEntryUid, courseActivity });
    } else {
      return await handleLesson({
        courseEntryUid,
        lessonEntryUid,
        lessonActivity,
      });
    }
  } else if (isLearningUrl && coursePath === 3) {
    return await handleCourse({ courseEntryUid, courseActivity });
  } else if (isLearningUrl ? coursePath === 5 : coursePath === 4) {
    return await handleLesson({
      courseEntryUid,
      lessonEntryUid,
      lessonActivity,
    });
  }
}
